import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appTooltip]',
  standalone: true // Use if your project is standalone
})
export class TooltipDirective {

  @Input() appTooltip: string | number = '';

  private tooltipElement: HTMLElement | undefined;

  constructor(private el: ElementRef,
    private renderer: Renderer2) {}

  @HostListener('mouseenter') onMouseEnter(): void {
    if (!this.appTooltip) return;

    // Create the tooltip element
    this.tooltipElement = this.renderer.createElement('span');
    this.renderer.setProperty(this.tooltipElement, 'textContent', this.appTooltip);
    this.renderer.addClass(this.tooltipElement, 'custom-tooltip'); // Add CSS class for styling

    // Append to the body or the host element's parent
    this.renderer.appendChild(document.body, this.tooltipElement);

    // Position the tooltip (simple example, more complex logic for perfect positioning)
    const hostPos = this.el.nativeElement.getBoundingClientRect();
    this.renderer.setStyle(this.tooltipElement, 'position', 'fixed');
    this.renderer.setStyle(this.tooltipElement, 'top', `${hostPos.bottom + window.scrollY}px`);
    this.renderer.setStyle(this.tooltipElement, 'left', `${hostPos.left + window.scrollX}px`);
  }

  @HostListener('mouseleave') onMouseLeave(): void {
    if (this.tooltipElement) {
      this.renderer.removeChild(document.body, this.tooltipElement);
      this.tooltipElement = undefined;
    }
  }
}
